export default __webpack_public_path__ + "dfc0df603c55ef9afb428988779f0a4b.png";